// You can write more code here

/* START OF COMPILED CODE */

import EntityGem from '../EntityGem';
/* START-USER-IMPORTS */
import { GameDataHandler } from '../../GameDataHandler';
import { app } from '../../core/App';
/* END-USER-IMPORTS */

export default class EntityMegaGem extends EntityGem {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 43, y ?? 57.25);

    // gem
    const gem = scene.add.image(0, 0, 'game', 'gem-pot.png');
    this.add(gem);

    // sparkle
    const sparkle = scene.add.image(28, -30, 'game', 'gem-sparkle.png');
    this.add(sparkle);

    // sparkle_1
    const sparkle_1 = scene.add.image(-3, -27, 'game', 'gem-sparkle.png');
    this.add(sparkle_1);

    // sparkle_2
    const sparkle_2 = scene.add.image(8, -44, 'game', 'gem-sparkle.png');
    this.add(sparkle_2);

    // sparkle_3
    const sparkle_3 = scene.add.image(-15, -40, 'game', 'gem-sparkle.png');
    this.add(sparkle_3);

    // sparkle_4
    const sparkle_4 = scene.add.image(-27, -25, 'game', 'gem-sparkle.png');
    this.add(sparkle_4);

    this.gem = gem;
    this.sparkle = sparkle;
    this.sparkle_1 = sparkle_1;
    this.sparkle_2 = sparkle_2;
    this.sparkle_3 = sparkle_3;
    this.sparkle_4 = sparkle_4;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private gem: Phaser.GameObjects.Image;
  private sparkle: Phaser.GameObjects.Image;
  private sparkle_1: Phaser.GameObjects.Image;
  private sparkle_2: Phaser.GameObjects.Image;
  private sparkle_3: Phaser.GameObjects.Image;
  private sparkle_4: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  protected injectMatter(target: Phaser.GameObjects.GameObject) {
    this.setSize(this.gem.displayWidth, this.gem.displayHeight);

    super.injectMatter(target);

    let x = this.x;
    let y = this.y;
  }

  protected score(): void {
    this.scene.registry.inc(GameDataHandler.keys.Score, 5);
    app.audioHandler.playSound(this.scene, 'SndMegaGemCollect', 'sfx');
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
